import moment from "moment";
import { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Stack from "@mui/material/Stack";
import { TextField, DialogActions, Box, Divider } from "@mui/material";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { HOURS_AND_COLORS } from "Common/constant";
// import Button from "@mui/material/Button";
import { Button } from "antd";
import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { APPOINTMENT_COLOR } from "Common/constant";
// import { Grid } from "@mui/material";
import { AVAILABILITY_ADD_ACTION } from "Common/constant";
import { AVAILABILITY_EDIT_ACTION } from "Common/constant";
import Grid from "@mui/material/Grid";
import { isValid } from "date-fns";
import { INVALID_TIME_ERROR_TXT } from "Common/constant";
import { END_LESSTHAN_START_TXT } from "Common/constant";
import { START_TIME_TXT } from "Common/constant";
import { END_TIME_TXT } from "Common/constant";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DigitalClock } from "@mui/x-date-pickers/DigitalClock";
import dayjs from "dayjs";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Popover from "@mui/material/Popover";

let top = 330;
let left = 680;

const shouldDisableEndTime = (value, view) => {
  const hour = value.hour();
  const minute = value.minute();

  if (view === "hours") {
    if (hour == 23) {
      return minute != 0 && minute != 30 && minute != 59;
    } else {
      return minute != 0 && minute != 30;
    }
  }
  return false;
};

const CustomSchedulerEditor = ({
  scheduler,
  handleConfirm,
  handleDelete,
  availabilities,
}) => {
  // const event = scheduler.edited;

  const availItem = availabilities.current.find((item) => {
    return moment(new Date(scheduler.state.start.value)).isBetween(
      new Date(item.start),
      new Date(item.end),
      "minutes",
      "[)"
    );
  });

  // const [isPopupChange, setIsPopupChange] = useState(false);

  const [currentEvent, setCurrentEvent] = useState(null);

  // const [startError, setStartError] = useState(null);

  const [endError, setEndError] = useState(null);

  const [saving, setSaving] = useState(false);

  const [deleting, setDeleting] = useState(false);

  const [isPOPOverOpen, setIsPOPOverOpen] = useState(false);

  const handlePopOverOpen = (event) => {
    setIsPOPOverOpen(true);
  };

  const handlePopOverClose = () => {
    setIsPOPOverOpen(false);
  };

  const handleStartChange = (value) => {
    // if (currentEvent.end) {
    setEndError(null);
    // }
    // setStartError(null);
    setCurrentEvent((prevState) => ({
      ...prevState,
      start: value,
    }));
    // if (!value) {
    //   setStartError("Start time is required");
    // }
  };

  const handleEndChange = (value) => {
    // if (currentEvent.start) {
    //   setStartError(null);
    // }
    setEndError(null);
    setCurrentEvent((prevState) => ({
      ...prevState,
      end: value,
    }));

    // if (!value) {
    //   setEndError("End time is required");
    // }
  };

  const handleSubmit = async () => {
    try {
      let start = new Date(currentEvent.start);
      let end = new Date(currentEvent.end);

      if (moment(end).isAfter(start)) {
        setSaving(true);
        if (currentEvent.action == AVAILABILITY_EDIT_ACTION) {
          handleConfirm(start, end, scheduler, availItem.id);
        } else {
          handleConfirm(start, end, scheduler);
        }

        // scheduler.close();
      } else {
        setEndError(END_LESSTHAN_START_TXT);
      }
    } catch (error) {}
  };

  const handleApptDelete = async () => {
    setIsPOPOverOpen(false);
    try {
      setDeleting(true);
      handleDelete(availItem.id, scheduler);
      // scheduler.close();
    } catch (error) {}
  };

  useEffect(() => {
    const action = availItem
      ? AVAILABILITY_EDIT_ACTION
      : AVAILABILITY_ADD_ACTION;
    if (availItem) {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const popoverHeight = 85;
      top = centerY + popoverHeight;
      left = centerX;
    }
    const day = availItem?.start
      ? moment(availItem?.start).format("dddd")
      : moment(scheduler.state.start.value).format("dddd");

    const start_time = availItem
      ? availItem.start
      : scheduler.state.start.value;
    const end_time = availItem ? availItem.end : scheduler.state.end.value;

    const dayEndTime =
      start_time.getHours() == 23 &&
      end_time.getHours() == 0 &&
      action == AVAILABILITY_ADD_ACTION;

    setCurrentEvent({
      start: dayjs(start_time),
      end: dayEndTime
        ? dayjs(start_time).set("hour", 23).set("minute", 59)
        : dayjs(end_time),
      dayName: day,
      action: action,
    });

    return () => {
      // setStartError(null);
      setEndError(null);
    };
  }, []);

  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#107569",
      },
    },
    typography: {
      button: {
        textTransform: "none",
      },
    },
  });

  return (
    <div style={{ width: "600px" }}>
      {currentEvent ? (
        <ThemeProvider theme={darkTheme}>
          <AppBar
            style={{ boxShadow: "none" }}
            position="static"
            color="primary"
          >
            <div className="Availability-header">
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <span>
                    {`${currentEvent.dayName} - ${
                      currentEvent.action == AVAILABILITY_EDIT_ACTION
                        ? "Edit"
                        : "Add"
                    } Availability`}
                  </span>
                </Grid>
                <Grid item>
                  <IconButton size="small" onClick={scheduler.close}>
                    <CloseIcon fontSize="medium" />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          </AppBar>
          {endError && (
            <Box sx={{ m: 1 }}>
              <Alert severity="error">{END_LESSTHAN_START_TXT}</Alert>
            </Box>
          )}
          <div style={{ padding: "1.2rem 0rem" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={10}
                justifyContent="center"
                alignItems="center"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <span className="time_slot_txt">{START_TIME_TXT}</span>
                  <DemoContainer components={["DigitalClock"]}>
                    <DemoItem>
                      <DigitalClock
                        timeStep={30}
                        value={currentEvent.start}
                        onChange={(value) => {
                          handleStartChange(value);
                        }}
                      />
                    </DemoItem>
                  </DemoContainer>
                </Stack>
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <span className="time_slot_txt">{END_TIME_TXT}</span>
                  <DemoContainer components={["DigitalClock"]}>
                    <DemoItem>
                      <DigitalClock
                        timeStep={1}
                        skipDisabled
                        shouldDisableTime={shouldDisableEndTime}
                        value={currentEvent.end}
                        onChange={(value) => {
                          handleEndChange(value);
                        }}
                      />
                    </DemoItem>
                  </DemoContainer>
                  {/* </div> */}
                </Stack>
              </Stack>
            </LocalizationProvider>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={4}>
              <TimePicker
                views={["hours"]}
                label="Start Time"
                value={currentEvent.start}
                // inputFormat="hh:mm A"
                // inputFormat="hh A"
                inputFormat="hh a"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!startError}
                    helperText={startError ?? startError}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "hh (am|pm)",
                    }}
                  />
                )}
                onOpen={() => {
                  setIsPopupChange(true);
                }}
                onClose={() => {
                  setIsPopupChange(false);
                }}
                onAccept={(value) => {
                  handleStartChange(value);
                }}
                onChange={(value) => {
                  if (!isPopupChange) {
                    handleStartChange(value);
                  }
                }}
                // onError={(reason, value) => {
                //   if (reason === "maxTime") {
                //     setStartError("start date should be less than end date");
                //   } else {
                //     setStartError(reason);
                //   }
                // }}
                // maxTime={
                //   currentEvent.end && startTimeRef?.current?.hour() != 23
                //     ? moment(new Date(currentEvent.end), "HH:mm")
                //     : null
                // }
              />
              <TimePicker
                views={["hours"]}
                label="End Time"
                // inputFormat="hh:mm A"
                // inputFormat="hh A"
                inputFormat="hh a"
                // ampm={false}
                value={currentEvent.end}
                // minutesStep={5}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!endError}
                    helperText={endError ?? endError}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "hh (am|pm)",
                    }}
                  />
                )}
                onOpen={() => {
                  setIsPopupChange(true);
                }}
                onClose={() => {
                  setIsPopupChange(false);
                }}
                onChange={(value) => {
                  if (!isPopupChange) {
                    handleEndChange(value);
                  }
                }}
                onAccept={(value) => {
                  handleEndChange(value);
                }}
                // onError={(reason, value) => {
                //   if (reason === "minTime") {
                //     setEndError("end date should be greater than start date");
                //   } else {
                //     setEndError(reason);
                //   }
                // }}
                // minTime={
                //   currentEvent.start && startTimeRef?.current?.hour() != 23
                //     ? moment(new Date(currentEvent.start), "HH:mm").add(
                //         1,
                //         "Hours"
                //       )
                //     : null
                // }
              />
            </Stack>
          </LocalizationProvider> */}
          </div>
          {/* <DialogActions> */}

          <div style={{ padding: "0.8rem 1rem 0.8rem 1rem" }}>
            <Grid container direction="row" alignItems="flex-end">
              <Grid item xs={18}>
                <Stack direction="row" spacing={4} justifyContent="center">
                  {currentEvent.action == AVAILABILITY_EDIT_ACTION && (
                    <>
                      <Button
                        variant="contained"
                        loading={deleting}
                        disabled={saving}
                        onClick={handlePopOverOpen}
                        className="scheduler-cancel-btn"
                      >
                        Delete
                      </Button>
                      <Popover
                        id="popover"
                        open={isPOPOverOpen}
                        anchorReference="anchorPosition"
                        anchorPosition={{ top, left }}
                        onClose={handlePopOverClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                      >
                        {availItem && (
                          <div className="delete-pop-container">
                            <div className="delete-pop-title">
                              Are you sure ?
                            </div>
                            <div className="delete-pop-desc">{`Deleting this availability will delete the ${dayjs(
                              availItem.start
                            ).format("h:mm A")} to ${dayjs(
                              availItem.end
                            ).format("h:mm A")} slot.`}</div>
                            <div className="delete-pop-actions">
                              <Button
                                className="update-btn"
                                variant="outlined"
                                onClick={handlePopOverClose}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="outlined"
                                className="scheduler-cancel-btn"
                                onClick={() => handleApptDelete(currentEvent)}
                              >
                                OK
                              </Button>
                            </div>
                          </div>
                        )}
                      </Popover>
                    </>
                  )}
                  <Button
                    variant="contained"
                    loading={saving}
                    disabled={!!endError || deleting}
                    onClick={handleSubmit}
                    className="update-btn"
                  >
                    Confirm
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </div>

          {/* </DialogActions> */}
        </ThemeProvider>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CustomSchedulerEditor;
